export default __webpack_public_path__ + "static/media/hero-dashboard-screen.f08cee72.png";